import React, { useMemo, useEffect } from "react";
import { Search, FilterAlt as FilterIcon } from "@mui/icons-material";
import { debounce } from "lodash";

import styles from "./SearchBar.module.scss";

const SearchBar = ({
  className,
  placeholder = "",
  onSearch,
  isFilterOpen,
  setIsFilterOpen,
}) => {
  const debouncedSearch = useMemo(
    () => debounce((val) => onSearch(val), 1000),
    [onSearch]
  );

  useEffect(() => {
    return () => {
      debouncedSearch.cancel();
    };
  }, [debouncedSearch]);

  return (
    <div className={styles[className] ? styles[className] : ""}>
      <form
        className={styles.searchBar}
        onSubmit={(e) => {
          e.preventDefault();
        }}
      >
        <input
          type="text"
          onChange={(e) => {
            e.preventDefault();
            debouncedSearch(e.target.value);
          }}
          placeholder={placeholder}
          className={styles.searchInput}
        />
        <button className={styles.searchButton}>
          <Search />
        </button>
      </form>
      <button
        onClick={() => setIsFilterOpen(!isFilterOpen)}
        className={styles.filterButton}
      >
        <FilterIcon fontSize="large" />
      </button>
    </div>
  );
};

export default SearchBar;
